import {
  NETWORTH_ERROR,
  NETWORTH_REQUEST,
  NETWORTH_SUCCESS,
  SYNCED_ERROR,
  SYNCED_REQUEST,
  SYNCED_SUCCESS,
  SYNCED_LAST_TEN_DAYS_ERROR,
  SYNCED_LAST_TEN_DAYS_REQUEST,
  SYNCED_LAST_TEN_DAYS_SUCCESS,
  RECEIVED_LAST_TEN_DAYS_ERROR,
  RECEIVED_LAST_TEN_DAYS_REQUEST,
  RECEIVED_LAST_TEN_DAYS_SUCCESS,
  LINKED_PAYPAL_ERROR,
  LINKED_PAYPAL_REQUEST,
  LINKED_PAYPAL_SUCCESS,
  DASHBOARD_ALL_ERROR,
  DASHBOARD_ALL_REQUEST,
  DASHBOARD_ALL_SUCCESS,
  FAILED_ERROR,
  FAILED_REQUEST,
  FAILED_SUCCESS,
  MISSING_ERROR,
  MISSING_REQUEST,
  MISSING_SUCCESS,
  QUEUED_REQUEST,
  QUEUED_SUCCESS,
  QUEUED_ERROR,
  PENDING_SUCCESS,
  PENDING_ERROR,
  PENDING_REQUEST,
  ADVANCE_SEARCH_REQUEST,
  ADVANCE_SEARCH_SUCCESS,
  ADVANCE_SEARCH_ERROR,
  INVALID_GATEWAY_SUCCESS,
  INVALID_GATEWAY_REQUEST,
  INVALID_GATEWAY_ERROR,
} from "./ActionType";

const idleOperation = {
  shopId: null,
  requestId: null,
  isRequest: false,
  error: null,
};

const validMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const operationFor = (state, key) =>
  state.countOperations?.[key] || idleOperation;

const startsOperation = (meta) => ({
  shopId: meta.shopId,
  requestId: meta.requestId,
  isRequest: true,
  error: null,
});

const matchesOperation = (operation, meta) =>
  validMeta(meta) &&
  operation?.shopId === meta.shopId &&
  operation?.requestId === meta.requestId;

const updateCountOperation = (state, key, operation) => ({
  ...(state.countOperations || {}),
  [key]: operation,
});

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: {},
  synced: {},
  syncedLastTenDays: [],
  receivedLastTenDays: [],
  linked_paypal: [],
  dashboard_all: {},
  failed: {},
  missing: {},
  queued: {},
  pending: {},
  advanceSearch: {},
  advanceSearchError: null,
  advanceSearchIsRequest: false,
  advanceSearchOperation: { ...idleOperation },
  countOperations: {
    dashboardAll: { ...idleOperation },
    failed: { ...idleOperation },
    missing: { ...idleOperation },
    pending: { ...idleOperation },
    synced: { ...idleOperation },
  },
  invalid_gateway: {},
};

const storeDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case NETWORTH_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        data: action.payload,
      };
    case NETWORTH_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
      };
    case NETWORTH_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: action.payload,
      };

    case SYNCED_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = operationFor(state, "synced");
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          synced: sameShop ? state.synced : {},
          countOperations: updateCountOperation(
            state,
            "synced",
            startsOperation(action.meta)
          ),
        };
      }
    case SYNCED_SUCCESS:
      if (!matchesOperation(operationFor(state, "synced"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        synced: action.payload,
        countOperations: updateCountOperation(state, "synced", {
          ...operationFor(state, "synced"),
          isRequest: false,
          error: null,
        }),
      };
    case SYNCED_ERROR:
      if (!matchesOperation(operationFor(state, "synced"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        countOperations: updateCountOperation(state, "synced", {
          ...operationFor(state, "synced"),
          isRequest: false,
          error: action.payload || "Synced-order count is unavailable.",
        }),
      };
    case SYNCED_LAST_TEN_DAYS_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        syncedLastTenDays: action.payload,
      };
    case SYNCED_LAST_TEN_DAYS_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        syncedLastTenDays: action.payload,
      };
    case SYNCED_LAST_TEN_DAYS_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        syncedLastTenDays: action.payload,
      };
    case RECEIVED_LAST_TEN_DAYS_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        receivedLastTenDays: action.payload,
      };
    case RECEIVED_LAST_TEN_DAYS_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        receivedLastTenDays: action.payload,
      };
    case RECEIVED_LAST_TEN_DAYS_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        receivedLastTenDays: action.payload,
      };
    case LINKED_PAYPAL_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        linked_paypal: action.payload,
      };
    case LINKED_PAYPAL_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        linked_paypal: action.payload,
      };
    case LINKED_PAYPAL_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        linked_paypal: action.payload,
      };
    case DASHBOARD_ALL_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = operationFor(state, "dashboardAll");
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          dashboard_all: sameShop ? state.dashboard_all : {},
          countOperations: updateCountOperation(
            state,
            "dashboardAll",
            startsOperation(action.meta)
          ),
        };
      }
    case DASHBOARD_ALL_SUCCESS:
      if (
        !matchesOperation(operationFor(state, "dashboardAll"), action.meta)
      ) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        dashboard_all: action.payload,
        countOperations: updateCountOperation(state, "dashboardAll", {
          ...operationFor(state, "dashboardAll"),
          isRequest: false,
          error: null,
        }),
      };
    case DASHBOARD_ALL_ERROR:
      if (
        !matchesOperation(operationFor(state, "dashboardAll"), action.meta)
      ) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        countOperations: updateCountOperation(state, "dashboardAll", {
          ...operationFor(state, "dashboardAll"),
          isRequest: false,
          error: action.payload || "All-orders count is unavailable.",
        }),
      };
    case FAILED_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = operationFor(state, "failed");
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          failed: sameShop ? state.failed : {},
          countOperations: updateCountOperation(
            state,
            "failed",
            startsOperation(action.meta)
          ),
        };
      }
    case FAILED_SUCCESS:
      if (!matchesOperation(operationFor(state, "failed"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        failed: action.payload,
        countOperations: updateCountOperation(state, "failed", {
          ...operationFor(state, "failed"),
          isRequest: false,
          error: null,
        }),
      };
    case FAILED_ERROR:
      if (!matchesOperation(operationFor(state, "failed"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        countOperations: updateCountOperation(state, "failed", {
          ...operationFor(state, "failed"),
          isRequest: false,
          error: action.payload || "Failed-order count is unavailable.",
        }),
      };
    case MISSING_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = operationFor(state, "missing");
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          missing: sameShop ? state.missing : {},
          countOperations: updateCountOperation(
            state,
            "missing",
            startsOperation(action.meta)
          ),
        };
      }
    case MISSING_SUCCESS:
      if (!matchesOperation(operationFor(state, "missing"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        missing: action.payload,
        countOperations: updateCountOperation(state, "missing", {
          ...operationFor(state, "missing"),
          isRequest: false,
          error: null,
        }),
      };
    case MISSING_ERROR:
      if (!matchesOperation(operationFor(state, "missing"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        countOperations: updateCountOperation(state, "missing", {
          ...operationFor(state, "missing"),
          isRequest: false,
          error: action.payload || "Missing-information count is unavailable.",
        }),
      };
    case QUEUED_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        queued: action.payload,
      };
    case QUEUED_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        queued: action.payload,
      };
    case QUEUED_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        queued: action.payload,
      };
    case PENDING_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = operationFor(state, "pending");
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          pending: sameShop ? state.pending : {},
          countOperations: updateCountOperation(
            state,
            "pending",
            startsOperation(action.meta)
          ),
        };
      }
    case PENDING_SUCCESS:
      if (!matchesOperation(operationFor(state, "pending"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        pending: action.payload,
        countOperations: updateCountOperation(state, "pending", {
          ...operationFor(state, "pending"),
          isRequest: false,
          error: null,
        }),
      };
    case PENDING_ERROR:
      if (!matchesOperation(operationFor(state, "pending"), action.meta)) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        countOperations: updateCountOperation(state, "pending", {
          ...operationFor(state, "pending"),
          isRequest: false,
          error: action.payload || "Processing-order count is unavailable.",
        }),
      };
    case ADVANCE_SEARCH_REQUEST:
      if (!validMeta(action.meta)) return state;
      {
        const previous = state.advanceSearchOperation || idleOperation;
        const sameShop = previous.shopId === action.meta.shopId;
        return {
          ...state,
          isRequest: true,
          isSuccess: false,
          isError: false,
          advanceSearch: sameShop ? state.advanceSearch : {},
          advanceSearchError: null,
          advanceSearchIsRequest: true,
          advanceSearchOperation: startsOperation(action.meta),
        };
      }
    case ADVANCE_SEARCH_SUCCESS:
      if (
        !matchesOperation(state.advanceSearchOperation, action.meta)
      ) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        advanceSearch: action.payload,
        advanceSearchError: null,
        advanceSearchIsRequest: false,
        advanceSearchOperation: {
          ...state.advanceSearchOperation,
          isRequest: false,
          error: null,
        },
      };
    case ADVANCE_SEARCH_ERROR:
      if (
        !matchesOperation(state.advanceSearchOperation, action.meta)
      ) {
        return state;
      }
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        advanceSearchError: action.payload,
        advanceSearchIsRequest: false,
        advanceSearchOperation: {
          ...state.advanceSearchOperation,
          isRequest: false,
          error: action.payload,
        },
      };

    case INVALID_GATEWAY_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        invalid_gateway: action.payload,
      };
    case INVALID_GATEWAY_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        invalid_gateway: action.payload,
      };
    case INVALID_GATEWAY_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        invalid_gateway: action.payload,
      };
    default:
      return state;
  }
};

export default storeDashboardReducer;
